import { data } from '../../svg/ThumbDown/data';
import { makeIcon } from '../makeIcon';

export const ThumbDown = makeIcon(data, 'thumb_down', 'ThumbDown');

export default ThumbDown;
